module.exports = __webpack_public_path__ + "static/img/mDcBanner 拷贝@2x.85707d71.png";